// Module
var code = "<div class=\"item-radio\"> <div class=\"radio{{class}}\" data-id=\"{{value}}\"> <span class=\"value en\">{{label}}</span> <span class=\"value vi\">{{label_vi}}</span> </div> </div>";
// Exports
module.exports = code;